import { gql } from "@apollo/client"
import { COMPACT_RESPONSE_SELECTION_OPTION_FIELDS } from "@data/processes/fragments/compactResponseSelectionFields"
import {
  CHECKBOX_JOB_STEP_FIELDS,
  DATE_TIME_JOB_STEP_FIELDS,
  FILES_JOB_STEP_FIELDS,
  INSTRUCTION_JOB_STEP_FIELDS,
  LONG_TEXT_JOB_STEP_FIELDS,
  MULTIPLE_CHOICE_JOB_STEP_FIELDS,
  NUMBER_JOB_STEP_FIELDS,
  NUMBER_RATING_JOB_STEP_FIELDS,
  PHOTOS_JOB_STEP_FIELDS,
  PROCESS_JOB_STEP_FIELDS,
  RANDOMIZER_JOB_STEP_FIELDS,
  SECTION_JOB_STEP_FIELDS,
  SELECTION_JOB_STEP_FIELDS,
  SIGNATURE_JOB_STEP_FIELDS,
  TEMPERATURE_TIMER_JOB_STEP_FIELDS,
  TEXT_JOB_STEP_FIELDS,
  TOUCHPOINT_JOB_STEP_FIELDS
} from "./steps"
import { JOB_STEP_COMPLETED_BY_FIELDS, JOB_STEP_NOTES_FIELDS, JOB_STEP_UPLOADS_FIELDS } from "./steps/common"

const JOB_STEP_FIELDS = gql`
  fragment JobStepFields on JobProcessStep {
    ...CheckboxJobStepFields
    ...DateTimeJobStepFields
    ...FilesJobStepFields
    ...InstructionJobStepFields
    ...LongTextJobStepFields
    ...MultipleChoiceJobStepFields
    ...NumberJobStepFields
    ...NumberRatingJobStepFields
    ...PhotosJobStepFields
    ...ProcessJobStepFields
    ...RandomizerJobStepFields
    ...SectionJobStepFields
    ...SelectionJobStepFields
    ...SignatureJobStepFields
    ...TemperatureTimerJobStepFields
    ...TextJobStepFields
    ...TouchpointJobStepFields
  }

  # Common fragments
  ${JOB_STEP_COMPLETED_BY_FIELDS}
  ${JOB_STEP_UPLOADS_FIELDS}
  ${JOB_STEP_NOTES_FIELDS}
  ${COMPACT_RESPONSE_SELECTION_OPTION_FIELDS}

  # Steps fragments
  ${CHECKBOX_JOB_STEP_FIELDS}
  ${DATE_TIME_JOB_STEP_FIELDS}
  ${FILES_JOB_STEP_FIELDS}
  ${INSTRUCTION_JOB_STEP_FIELDS}
  ${LONG_TEXT_JOB_STEP_FIELDS}
  ${MULTIPLE_CHOICE_JOB_STEP_FIELDS}
  ${NUMBER_JOB_STEP_FIELDS}
  ${NUMBER_RATING_JOB_STEP_FIELDS}
  ${PHOTOS_JOB_STEP_FIELDS}
  ${PROCESS_JOB_STEP_FIELDS}
  ${RANDOMIZER_JOB_STEP_FIELDS}
  ${SECTION_JOB_STEP_FIELDS}
  ${SELECTION_JOB_STEP_FIELDS}
  ${SIGNATURE_JOB_STEP_FIELDS}
  ${TEMPERATURE_TIMER_JOB_STEP_FIELDS}
  ${TEXT_JOB_STEP_FIELDS}
  ${TOUCHPOINT_JOB_STEP_FIELDS}
`

export { JOB_STEP_FIELDS }
